<template>
  <QRCodeScanner :state="state" :title="title" />
</template>

<script>
import QRCodeScanner from "@/components/QRCodeScanner";

export default {
  name: "ScanQRCode",
  props: {
    state: String,  //state is property that will be included into the result of scanning, so different handlings can be applied
    title: String
  },
  components: {
    QRCodeScanner,
  },
  activated() {
    this.setStatusBackgroundBarColor("#000000");
  },
  deactivated() {
    this.setThemeColorByMode();
  },
};
</script>